let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("SBkY7")).then(() => parcelRequire('30ibK'));